import type { Box } from "@/components/guide/story";

// Where the chapters meet: a list's first row is the box the next chapter
// opens from, and every close-up opens into the same panel.
export const HOLDER: Box = { x: 20, y: 18, w: 280, h: 146 };
export const FIRST_ROW: Box = { x: 28, y: 60, w: 264, h: 26 };
// A chosen row's look as it grows: the list's hover fill and selection border.
// Plain tokens: Chrome turns an SVG fill between color-mix() keyframes black.
export const MARKED = {
  fill: "var(--color-bg-hover)",
  stroke: "var(--color-selected)",
};
